import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { rootPaths } from 'routes/paths';
import { AppLayout } from 'features/app/components/AppLayout';
import { myGiftCardsPaths } from 'features/my-gift-cards/routes/paths';
import { MyGiftCardsRouter } from 'features/my-gift-cards/routes';
import { orderHistoryPaths } from 'features/order-history/routes/paths';
import { OrderHistoryRouter } from 'features/order-history/routes';
import { usersPaths } from 'features/users/routes/paths';
import { UsersRouter } from 'features/users/routes';
import { redemptionsPaths } from 'features/redemptions/routes/paths';
import { RedemptionsRouter } from 'features/redemptions/routes';
import { tutorialsPaths } from 'features/tutorials/routes/paths';
import { TutorialsRouter } from 'features/tutorials/routes';
import { dashboardPaths } from 'features/dashboard/routes/paths';
import { DashboardRouter } from 'features/dashboard/routes';
import { financePaths } from 'features/finance/routes/paths';
import { BalanceAndTopUpPage } from 'features/finance/pages/BalanceAndTopUpPage';
import { getStartedPaths } from 'features/get-started/routes/paths';
import { GetStartedRoutes } from 'features/get-started/routes';
import { SubscriptionRouter } from 'features/subscription/routes';
import { subscriptionPaths } from 'features/subscription/routes/paths';
import { appRoutes } from './paths';

export const AppRouter = () => {
  return (
    <AppLayout>
      <Switch>
        <Route path={myGiftCardsPaths.static.root} component={MyGiftCardsRouter} />
        <Route path={subscriptionPaths.static.root} component={SubscriptionRouter} />
        <Route path={orderHistoryPaths.static.root} component={OrderHistoryRouter} />
        <Route path={usersPaths.static.root} component={UsersRouter} />
        <Route path={redemptionsPaths.static.root} component={RedemptionsRouter} />
        <Route path={tutorialsPaths.static.root} component={TutorialsRouter} />
        <Route path={getStartedPaths.static.root} component={GetStartedRoutes} />
        <Route path={dashboardPaths.static.root} component={DashboardRouter} />
        <Route path={financePaths.static.balanceAndTopUp} exact component={BalanceAndTopUpPage} />

        <Route exact path={appRoutes.static.root}>
          <Redirect to={dashboardPaths.static.root} />
        </Route>
        <Route>
          <Redirect to={rootPaths.static.notFound} />
        </Route>
      </Switch>
    </AppLayout>
  );
};
